/**
 * 자리 뒤에 문자들 마스킹 처리
 * @param str
 * @param index
 * @returns {string}
 */
export const setMasking = (str, startIndex = str.length - 3) => {
  if (this.isEmpty(str)) return '';
  const temp = str.substring(0, startIndex);
  const temp2 = str.substring(startIndex, str.length).replace(/\w/g, '*');
  // return str.replace(/(?<=.{3})./gi, '*')
  // str.replace(new RegExp('(?<=.{' + startIndex + '}).', 'gi'), '*');
  return `${temp}${temp2}`;
};
/**
 * 중간글자 마스킹 처리
 * @param strName
 * @return { string }
 * */
export const setMidMasking = strName => {
  if (this.isEmpty(strName)) return '';
  if (strName.length > 2) {
    const originName = strName.split('');
    originName.forEach((name, i) => {
      if (i === 0 || i === originName.length - 1) return '';
      originName[i] = '*';
    });
    const joinName = originName.join();
    return joinName.replace(/,/g, '');
  } else {
    const pattern = /.$/; // 정규식
    return strName.replace(pattern, '*');
  }
};

export default {
  setMasking,
  setMidMasking
};
